import React from "react";
import "./SeparatorStyles.css";

export default function Separator({ children, ...restProps }) {
  return (
    <div className="separator" {...restProps} />
  );
}